
import { Component, Vue } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import NotificationEvent from "@/resources/mixins/notifications/notificationEvent";
@Component({})
export default class ActivateUser extends mixins(NotificationEvent) {
  mounted() {
    const { token, space, hasOnboarding, room } = this.$route.query;
    this.$store.dispatch("UserStore/activateUserAction", {
      token,
      space,
      callback: (response) => {
        if (response.data.status === "KO") {
          this.onError(
            this.$i18n.t("notifications.titles.error"),
            this.$i18n.t(`notifications.apiMessage.${response.data.code}`)
          );
          this.$router.push("/").catch(() => {
            // do nothing
          });
        } else {
          localStorage.setItem("space_default", space.toString());
          localStorage.setItem("city", "OFF");
          localStorage.setItem(
            "hasOnboarding",
            hasOnboarding ? hasOnboarding.toString() : "true"
          );
          if (room) localStorage.setItem("room", room.toString());
          else localStorage.removeItem("room");
          this.$router.push("/").catch(() => {
            // do nothing
          });
          setTimeout(() => {
            location.reload();
          }, 1000);
        }

        //window.location.reload();
      },
      callbackError: () => {
        this.onError(
          this.$i18n.t("notifications.titles.error"),
          this.$i18n.t("notifications.errorMessages.activateUser")
        );
        this.$router.push("/").catch(() => {
          // do nothing
        });
      },
    });
  }
}
